/* MODIFY THIS */

import { useGetBingoGameQuery } from "bingo/api/bingo-game.api";
import { useParams } from "react-router-dom";
import { BingoGameAdminForm } from "bingo/components/forms/BingoGameAdminForm";

export function BingoGameAdminView({
  isCreateMode,
}: {
  isCreateMode: boolean;
}) {
  const { bingoGameId } = useParams<{ bingoGameId: string }>();
  const { data: bingoGame } = useGetBingoGameQuery(bingoGameId!);

  console.log("bingogame", bingoGame);
  return (
    <>
      {bingoGame ? (
        <BingoGameAdminForm
          bingoGame={bingoGame}
          bingoGameId={bingoGameId!}
          editMode={true}
        />
      ) : null}

      {!bingoGame && !bingoGame ? (
        <BingoGameAdminForm editMode={false} />
      ) : null}
    </>
  );
}
